import React, { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import ReporterSidebar from './ReporterSidebar';
import ReporterTopbar from './ReporterTopbar';


const pageTitles = {
  '/reporter/dashboard': { ne: 'ड्यासबोर्ड', en: 'Dashboard' },
  '/reporter/articles': { ne: 'मेरा लेखहरू', en: 'My Articles' },
  '/reporter/create-article': { ne: 'लेख सिर्जना गर्नुहोस्', en: 'Create Article' },
  '/reporter/events': { ne: 'कार्यक्रम कभरेज', en: 'Event Coverage' },
  '/reporter/media': { ne: 'मिडिया अपलोड', en: 'Media Uploads' },
  '/reporter/profile': { ne: 'प्रोफाइल', en: 'Profile' },
};

const ReporterLayout = () => {
  const { language, toggleLanguage } = useLanguage();
  const { isAuthenticated, user, loading } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);


  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream">
        <div
          className="spinner"
          style={{
            width: 36,
            height: 36,
            borderColor: 'rgba(45,122,58,0.15)',
            borderTopColor: 'var(--green)',
          }}
        />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== 'reporter') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream p-8">
        <div className="max-w-md rounded-3xl border border-char-100 bg-white p-8 text-center shadow-card">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-error-50">
            <svg className="h-8 w-8 text-error" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m0 0v2m0-2h2m-2 0H10m9.364-7.364A9 9 0 1112 3a9 9 0 017.364 4.636z" />
            </svg>
          </div>
          <h2 className="mb-2 text-xl font-extrabold text-char-900">
            {language === 'ne' ? 'पहुँच अस्वीकृत' : 'Access Denied'}
          </h2>
          <p className="mb-6 text-char-600">
            {language === 'ne'
              ? 'यो पृष्ठ केवल रिपोर्टरहरूको लागि हो।'
              : 'This page is only accessible to reporters.'}
          </p>
          <a
            href="/"
            className="inline-flex items-center gap-2 rounded-xl bg-primary px-5 py-2.5 text-sm font-extrabold text-white shadow-green transition-all hover:-translate-y-0.5 hover:bg-primary-500 hover:shadow-green-hover"
          >
            {language === 'ne' ? 'गृहपृष्ठमा जानुहोस्' : 'Go to Homepage'}
          </a>
        </div>
      </div>
    );
  }

  const path = window.location.pathname;
  const titleObj = pageTitles[path] || { ne: 'ड्यासबोर्ड', en: 'Dashboard' };
  const title = titleObj[language] || titleObj.en;

  return (
    <div className="min-h-screen bg-cream">
      <ReporterSidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        language={language}
      />

      <div className="lg:pl-64">
        <ReporterTopbar
          title={title}
          onToggleSidebar={() => setSidebarOpen(true)}
          language={language}
          onToggleLanguage={toggleLanguage}
        />

        <main className="p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ReporterLayout;
